<template>
  <div>
    <div class="input-container">
      <b-row>
        <b-col>
          <label class="input-title">Task name</label>
          <b-form-input
              type="text"
              :state="informationValidation.isTaskNameProvided"
              v-model="collaborativeTaskDetails.taskName"></b-form-input>

          <b-form-invalid-feedback v-if="!informationValidation.isTaskNameProvided">
            This field must not be empty.
          </b-form-invalid-feedback>
        </b-col>
      </b-row>
    </div>
    <div class="input-container">
      <b-row>
        <b-col>
          <label class="input-title">To-do list name</label>
          <b-form-input
              type="text"
              v-model="collaborativeTaskDetails.toDoListName"
              disabled></b-form-input>
        </b-col>
      </b-row>
    </div>
    <div class="input-container">
      <b-row>
        <b-col>
          <label class="input-title">Assignee</label>
          <b-form-select v-model="collaborativeTaskDetails.assigneeId" :options="assigneeList"></b-form-select>
        </b-col>
      </b-row>
    </div>
    <div class="input-container">
      <b-row>
        <b-col>
          <label class="input-title">Priority</label>
          <b-form-select v-model="collaborativeTaskDetails.priority" :options="priorityOptions"></b-form-select>
        </b-col>
      </b-row>
    </div>
    <div class="input-container">
      <b-row>
        <b-col>
          <label class="input-title">Description</label>
          <b-form-input
              type="text"
              v-model="collaborativeTaskDetails.description"></b-form-input>
        </b-col>
      </b-row>
    </div>
    <div class="input-container">
      <b-row>
        <b-col>
          <label class="input-title">Due date</label>
          <b-form-datepicker
              v-model="collaborativeTaskDetails.dueDate"></b-form-datepicker>
          <b-button v-if="collaborativeTaskDetails.dueDate" variant="outline-danger" @click="removeDueDate"
                    id="removeDueDateButton">
            Remove due date
          </b-button>
        </b-col>
      </b-row>
    </div>
    <div class="input-container">
      <b-row>
        <b-col>
          <label class="input-title">Location</label>
          <b-form-input
              type="text"
              v-model="collaborativeTaskDetails.location"></b-form-input>
        </b-col>
      </b-row>
    </div>
    <div class="input-container">
      <b-row>
        <b-col>
          <label class="input-title">Attachment</label>
          <br>
          <input type="file" accept="image/*" @change="onFileChange" id="attachment-input"/>
          <b-button v-if="attachmentUrl" variant="outline-danger" @click="removeAttachment"
                    id="removeAttachmentButton">
            Remove attachment
          </b-button>
          <div id="preview">
            <img v-if="attachmentUrl" :src="attachmentUrl"/>
          </div>
        </b-col>
      </b-row>
    </div>
    <hr>
    <b-button class="main-input-button" block @click="createCollaborativeTask">Create task</b-button>
  </div>
</template>

<script>
  import {required} from "vuelidate/lib/validators";
  import {db} from "../../../main";

  export default {
    name: "CollaborativeTaskCreation",
    data() {
      return {
        collaborativeTaskDetails: {
          toDoListId: null,
          taskName: null,
          toDoListName: this.$store.getters.currentToDoListName,
          assigneeId: null,
          assigneeName: null,
          priority: 1,
          description: null,
          dueDate: null,
          location: null,
          attachmentFile: null,
          taskType: 'Collaborative Task'
        },
        informationValidation: {
          isTaskNameProvided: null,
        },
        assigneeList: [
          {value: null, text: 'Unassigned (Not assigned)'}
        ],
        priorityOptions: [
          {value: 0, text: 'High'},
          {value: 1, text: 'Medium'},
          {value: 2, text: 'Low'}
        ],
        attachmentUrl: null
      }
    },
    validations: {
      collaborativeTaskDetails: {
        taskName: {
          required
        }
      }
    },
    methods: {
      onFileChange(e) {
        this.collaborativeTaskDetails.attachmentFile = e.target.files[0];

        if (this.collaborativeTaskDetails.attachmentFile !== undefined) {
          this.attachmentUrl = URL.createObjectURL(this.collaborativeTaskDetails.attachmentFile);
        } else {
          this.attachmentUrl = null
        }
      },
      removeAttachment() {
        this.attachmentUrl = null
        document.getElementById("attachment-input").value = "";
      },
      removeDueDate() {
        this.collaborativeTaskDetails.dueDate = null
      },
      assigneeNameComparatorFunction(a, b) {
        const collaboratorAName = a.text
        const collaboratorBName = b.text

        let comparison = 0
        if (collaboratorAName > collaboratorBName) {
          comparison = 1
        } else if (collaboratorAName < collaboratorBName) {
          comparison = -1
        }

        return comparison
      },
      createCollaborativeTask() {
        // check if all information is valid
        let isValid = true

        if (!this.$v.collaborativeTaskDetails.taskName.required) {
          this.informationValidation.isTaskNameProvided = false
          isValid = false
        } else {
          this.informationValidation.isTaskNameProvided = true
        }

        if (isValid) {
          // retrieve the assignee name to be added in the collaborativeTaskDetails
          const retrievedAssigneeName = this.assigneeList.filter(obj => {
            return obj.value === this.collaborativeTaskDetails.assigneeId
          })
          this.collaborativeTaskDetails.assigneeName = retrievedAssigneeName[0].text !== 'Unassigned (Not assigned)' ? retrievedAssigneeName[0].text : null

          this.$store.dispatch('createNewCollaborativeTask', this.collaborativeTaskDetails)
          this.hideModal('creation-modal')
        }
      },
      hideModal(id) {
        this.$root.$emit('bv::hide::modal', id)
      }
    },
    mounted() {
      this.collaborativeTaskDetails.toDoListId = this.$route.params.collaborativeListId

      // retrieve the list collaborator
      db
        .collectionGroup('user_collaborative_to_do_list_participation')
        .where('collaborativeToDoListId', '==', this.collaborativeTaskDetails.toDoListId)
        .onSnapshot(querySnapshot => {
          const userCollaborativeToDoListParticipationObject = querySnapshot.docs.map(doc => doc.data())

          let tempAssigneeList = []

          userCollaborativeToDoListParticipationObject.forEach(collaborator => {
            let assignee = {
              value: collaborator.collaboratorId,
              text: collaborator.collaboratorName
            }
            tempAssigneeList.push(assignee)
          })

          // sort the assignee list alphabetically before adding the collaborator to the assignee list
          let sortedAssigneeList = tempAssigneeList.sort(this.assigneeNameComparatorFunction)

          sortedAssigneeList.forEach(assignee => {
            this.assigneeList.push(assignee)
          })
        })
    }
  }
</script>

<style scoped>
  #removeDueDateButton {
    margin-top: 1em;
  }

  #removeAttachmentButton {
    margin-top: 1em;
    margin-bottom: 1em;
  }

  #preview {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #preview img {
    max-width: 100%;
    max-height: 500px;
  }

  .add-attachment-button {
    display: block;
  }

  .input-container {
    margin-bottom: 1em;
  }

  .input-title {
    font-weight: bold;
  }

  .secondary-input-button {
    background-color: white;
    color: #212441;
    padding: 0.5em;
  }

  .secondary-input-button:hover {
    background-color: #212441;
    color: white;
    padding: 0.5em;
  }

  .main-input-button {
    font-weight: bold;
    background-color: #212441;
    padding: 0.5em;
  }

  .main-input-button:hover {
    font-weight: bold;
    background-color: #FFFFFF;
    color: #212441;
    padding: 0.5em;
  }
</style>
